/**
 * Method-level "last used" memory for the sign-in door: which method this
 * browser last completed a verified sign-in with. It decides only which door
 * `InlineAuth` opens first on the next visit — never an authorization, and
 * never identity (no name, no email; the cautious end of the last-used
 * pattern). Written exclusively by InlineAuth's two success paths.
 */
const KEY = 'mm-last-auth-method';

export type LastAuthMethod = 'google' | 'email';

export function readLastAuthMethod(): LastAuthMethod | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === 'google' || value === 'email' ? value : null;
  } catch {
    return null;
  }
}

export function writeLastAuthMethod(method: LastAuthMethod): void {
  try {
    window.localStorage.setItem(KEY, method);
  } catch {
    // Storage unavailable (private mode) — the door just opens on its default.
  }
}
